import { createPortalSystem } from '../portal-system/createPortalSystem';

/**
 * Portal system for overlay dock portal container elements.
 */
export const overlayDockPortalSystem = createPortalSystem('OverlayDockPortal');
